module.exports = __webpack_public_path__ + "static/media/relaxmit-2.106c5e74.jpg";